import PropTypes from 'prop-types';
import { getPatientCcmStatus } from 'utils';

const CcmStatusIndicator = ({ ccmStatus }) => {
  const { label, color } = getPatientCcmStatus(ccmStatus);
  return (
    <div style={{ backgroundColor: color }} className="ccm-status-indicator">
      {label}
    </div>
  );
};

CcmStatusIndicator.propTypes = {
  ccmStatus: PropTypes.bool,
};

export default CcmStatusIndicator;
